import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SelectElement} from "../../../../components/common/select/select.model";
import {BehaviorSubject} from "rxjs";
import {SelectFilterElement} from "../../../../components/common/select-filter/select-filter.model";
import {UntypedFormGroup} from "@angular/forms";
import {Focussable} from '../../../../components/common/focussable';

@Component({
    selector: 'app-multiple-select-filter-simple',
    templateUrl: './multiple-select-filter-simple.component.html',
})
export class MultipleSelectFilterSimpleComponent implements OnInit, OnChanges {

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() elements: SelectElement[] = [];
    @Input() loading = false;

    @Output() focussedEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() selectionChangedEvent = new EventEmitter<any[]>();

    filteredElements: BehaviorSubject<SelectFilterElement<string, string>[]> =
        new BehaviorSubject<SelectFilterElement<string, string>[]>([]);

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['elements']) {
            if (this.elements) {
                this.filteredElements.next(this.elements.map(value => new SelectFilterElement(value.value, value.value, value.label)));
            }
        }
    }

    selectionChanged(values: string[]) {
        console.log('selectionChanged event', values);
        this.selectionChangedEvent.emit(values
            .map(value => this.elements.find(element => element.value === value))
            .filter(value => value));
    }

    filter = (criteria: string, value: string) => {
        return (value).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    focussed() {
        this.focussedEvent.emit();
    }


}
